import { render, staticRenderFns } from "./ClientMSC2SupervisionCourse.vue?vue&type=template&id=128f713d&scoped=true&"
import script from "./ClientMSC2SupervisionCourse.vue?vue&type=script&lang=js&"
export * from "./ClientMSC2SupervisionCourse.vue?vue&type=script&lang=js&"
import style0 from "./ClientMSC2SupervisionCourse.vue?vue&type=style&index=0&id=128f713d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f713d",
  null
  
)

export default component.exports